import { render, staticRenderFns } from "./MessageDropdown.vue?vue&type=template&id=ee4a7706&scoped=true"
import script from "./MessageDropdown.vue?vue&type=script&lang=js"
export * from "./MessageDropdown.vue?vue&type=script&lang=js"
import style0 from "./MessageDropdown.vue?vue&type=style&index=0&id=ee4a7706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4a7706",
  null
  
)

export default component.exports